module.exports = __webpack_public_path__ + "80b8be614192be288e5e2bae4ae59807.png";